// Module
var code = "<div>\n    <div class=\"vx-float-field\">\n        <label ng-show=\"text\" class=\"vx-float-field-show-hide\">{{label}}</label>\n        <input type=\"{{type}}\" class=\"form-control\" ng-model=\"text\"\n               placeholder=\"{{label}}\" />\n    </div>\n</div>";
// Exports
module.exports = code;